<template>
  <CardPage
    :loading="loading"
    :done="done"
    :done-message="doneMessage"
    done-image="/open-email.svg"
    secondary-to="/login"
    :secondary-text="'Login instead?'"
    :description="'Grant the MailSlurp support team access to your account to perform actions on your behalf'"
    :title="'Grant support access'"
    @submit="submit"
  >
    <FormGrouping>
      <FormRow :label="'Grant type'" required>
        <FormSelect
          v-model="grantType"
          show-all
          data-id="grant-type"
          :options="grantTypeOptions"
          name="grantType"
          required
        />
      </FormRow>
      <FormRow :label="'Message'" :required="true">
        <FormInput
          v-model="message"
          data-id="message-input"
          :required="true"
          name="message"
          type="text"
        />
      </FormRow>
      <FormRow
        v-if="grantType === 'EMAIL'"
        :label="'Your email'"
        :required="grantType === 'EMAIL'"
      >
        <FormInput
          v-model="username"
          data-id="user-email-input"
          :required="grantType === 'EMAIL'"
          name="email"
          type="text"
        />
      </FormRow>
      <FormRow v-else :label="'User ID'" :required="grantType === 'USER_ID'">
        <FormInput
          v-model="userId"
          data-id="user-id-input"
          :required="grantType === 'USER_ID'"
          name="userId"
          type="text"
        />
      </FormRow>
    </FormGrouping>
  </CardPage>
</template>

<script setup lang="ts">
import type {
  EmptyResponseDto,
  GrantAdminAccessToUserIdRequest as GrantAdminAccessToUserIdUsingPOSTRequest,
} from '@mailslurp/admin-sdk';
import CardPage from '../components/CardPage.vue';

import { computed, ref } from 'vue';
import { useStore3 } from '../store/main';
import FormGrouping from '../components/form/FormGrouping.vue';
import FormInput from '../components/form/FormInput.vue';
import FormSelect from '../components/form/FormSelect.vue';
import FormRow from '../components/form/FormRow.vue';

const store3 = useStore3();
const username = ref('');
const message = ref('');
const userId = ref('');
const loading = ref(false);
const done = ref<boolean>(false);
const doneMessage = ref<string>('');
const grantType = ref<'EMAIL' | 'USER_ID'>('EMAIL');
const grantTypeOptions = computed(() => {
  return [
    { text: 'Your email', value: 'EMAIL' },
    { text: 'User ID', value: 'USER_ID' },
  ];
});

const submit = async () => {
  store3.setFlash(null);
  loading.value = true;
  try {
    const options: GrantAdminAccessToUserIdUsingPOSTRequest = {
      emailAddress: username.value,
      userId: userId.value,
      redirectDevUrl: undefined,
      message: message.value,
    };
    const response: EmptyResponseDto = await store3.grantAdminAccess(options);
    done.value = true;
    doneMessage.value =
      response.message ||
      ('An access email has been sent to support. Please wait up to 24 hours for a response.' as string);
    loading.value = false;
  } catch (e: unknown) {
    loading.value = false;
    done.value = true;
    doneMessage.value = 'Error. Please try again.' as string;
    store3.setError({
      error: e,
    });
  }
};
</script>
